import { LOGIN, LOGIN_SUCCESS, LOGIN_ERROR, LOGIN_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UserLogin = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case LOGIN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case LOGIN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case LOGIN_EMPTY:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        message: null,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UserLogin;
